import AddressSearchModal from './AddressSearchModal'

export default AddressSearchModal
